/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./roleEdit.vue?vue&type=template&id=6356783e"
import script from "./roleEdit.vue?vue&type=script&lang=js"
export * from "./roleEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports